<!-- 
	分享按钮组件 F03
	1、显示风格类型（1样式一 2样式二）
	2、过度颜色：开始颜色、结束颜色
	3、按钮名称
	4、阴影颜色
	5、字体颜色
-->
<template>
	<view class="component-wrapper">
		<up-button type="primary" :color="colorStyle" :style="buttonStyle" shape="circle" :iconColor="data.fontColor" :text="buttomName == null ? '分享好友' : buttomName" @click="sharedEvent()"></up-button>
	</view>
</template>

<script setup>
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//显示风格类型（1样式一 2样式二）
					"showType": {
						type: Number,
						default: 1
					},
					//开始颜色
					"startColor": {
						type: String,
						default: '#17ced5'
					},
					//结束颜色
					"endColor": {
						type: String,
						default: '#30c79e'
					},
					//按钮名称
					"buttomName": {
						type: String,
						default: '分享好友'
					},
					//阴影颜色
					"shadowColor": {
						type: String,
						default: '#FFFFFF'
					},
					//字体颜色
					"fontColor": {
						type: String,
						default: '#FFFFFF'
					}
				}
			}
		}
	})
	
	/**
	 * 渐进色样式
	 */
	const colorStyle = computed(() => {
		const {
			startColor,
			endColor
		} = props.data;
		return `
			linear-gradient(${startColor}, ${endColor})
		`;
	});
	
	/**
	 * button样式
	 */
	const buttonStyle = computed(() => {
		const {
			shadowColor
		} = props.data;
		return `
			box-shadow: 0px 0px 5px 5px ${shadowColor == null ? '#FFFFFF' : shadowColor};
			width:80%;
		`;
	});
	
	
	/**
	 * 分享事件
	 */
	function sharedEvent(){
		// #ifdef MP-WEIXIN
		uni.$u.toast("功能实现中");
		// #endif
		// #ifndef MP-WEIXIN
		uni.$u.toast("仅支持小程序分享");
		// #endif
	}
	
</script>

<style lang="less" scoped>
	.component-wrapper {
		background-color: #FFFFFF;
		margin: 10px;
	}
</style>
